<div
	class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary c-portlet_box_specs bee-shadow {{
		sectionclass
	}}"
	style="position: relative; display: block"
>
	<app-loader [showLoader]="showLoad"></app-loader>
	<div class="c-portlet__header sem-keywords-header">
		<div class="o-stack__cell">
			<div class="card-title keywords-header primary-color">
				<h5>{{ sectiontitle }}</h5>
				<div *ngIf="!isR9" class="description">
					Click on any row under an ad group to view details and ad creatives.
				</div>
				<div *ngIf="isR9 && hasData" class="description">
					Click on any row under an ad group to view details and ad creatives.
				</div>
				<span class="datatable-icon" *ngIf="hasData">
					<a
						href="javascript:void(0)"
						class="datatable_download_icon"
						(click)="downloadCSV($event)"
						target="_blank"
						*ngIf="downloadConfiguration && downloadConfiguration.enableDownload"
					>
						<i class="fa fa-download" aria-hidden="true" *ngIf="!downloadConfiguration.downloadPNG"></i>
						<img
							src="../../../../../assets/images/Download_Icon.svg"
							class="downloadIcon"
							*ngIf="downloadConfiguration.downloadPNG"
						/>
					</a>
				</span>
			</div>
		</div>
	</div>
	<div class="analytics-portlet-content" *ngIf="hasData">
		<div>
			<div class="container-table">
				<div *ngIf="!isR10" class="header rows">
					<div
						class="column-name"
						*ngFor="let column of columns; let icon = index"
						(click)="sortDataBasedOnKey(column.columnKey, column.type, icon)"
						[ngClass]="{ active: column.columnKey == sortdataby }"
					>
						<span *ngIf="!showTooltip">{{ column.name }}</span>
						<span
							*ngIf="showTooltip"
							appTooltip
							[attr.title]="column.columnTooltip"
							data-size="small"
							[options]="tooltipOptions"
							>{{ column.name }}</span
						><span class="sort-icons">
							<i class="fa fal fa-long-arrow-down"></i><i class="fa fal fa-long-arrow-up"></i>
						</span>
					</div>
				</div>
				<div *ngIf="isR10" class="header rows">
					<div
						class="column-name"
						*ngFor="let column of columns; let icon = index"
						(click)="sortDataBasedOnKey(column.columnKey, column.type, icon)"
						[ngClass]="{ active: column.columnKey == sortdataby, descending: column.columnKey == sortdataby }"
					>
						<span>{{ column.name }}</span
						><span class="sort-icons">
							<i class="fa fal fa-long-arrow-down"></i><i class="fa fal fa-long-arrow-up"></i>
						</span>
					</div>
				</div>
				<div class="container-table-body">
					<div
						class="adgroups-rows"
						*ngFor="
							let adgroup of formattedData
								| paginate : { id: 'ad_group_pagination', itemsPerPage: itemsPerPage, currentPage: p2 };
							let i = index
						"
					>
						<div class="rows">
							<div class="adgroup-values" *ngFor="let column of columns; let icon = index">
								<span *ngIf="column.suffix">{{ adgroup[column.columnKey] | number : '0.2-2' }}{{ column.suffix }}</span>
								<span *ngIf="!column.suffix && column.type == 'number'">{{ adgroup[column.columnKey] | number }}</span>
								<span *ngIf="column.type == 'string' || !column.type">{{ adgroup[column.columnKey] }}</span>
								<span class="openIcon" *ngIf="icon == 0" (click)="expand('adgroup', i, null, true)">
									<img src="../../../../../assets/images/right_arrow.png" />
								</span>
								<span class="closeIcon" *ngIf="icon == 0" (click)="expand('adgroup', i, null, false)">
									<img src="../../../../../assets/images/right_arrow.png"
								/></span>
							</div>
						</div>
						<div class="ads-details" [ngClass]="{ scroll: adgroup.ads.length > 4 }">
							<div class="ads-rows" *ngFor="let ads of adgroup.ads; let k = index" [ngClass]="ads.ad_class">
								<div class="rows">
									<div class="ads-values" *ngFor="let column of columns; let icon = index">
										<span class="ad-name">
											<span *ngIf="column.suffix"
												>{{ ads[column.columnKey] | number : '0.2-2' }}{{ column.suffix }}</span
											>
											<span *ngIf="!column.suffix && column.type == 'number'">{{
												ads[column.columnKey] | number
											}}</span>
											<span
												*ngIf="column.type == 'string' || !column.type"
												appTooltip
												title="Tooltip"
												[title]="ads.tooltipHeadlines"
												data-size="small"
												[options]="tooltipOptions"
											>
												<span *ngIf="ads.ad_type == 'Dynamically_generated_headline'">[</span>
												{{ ads[column.columnKey] }}
												<span *ngIf="ads.ad_type == 'Dynamically_generated_headline'">]</span>
											</span>
										</span>
										<span class="ad-description" *ngIf="icon == 0">{{ ads.description }}</span>
										<span
											class="openIcon"
											*ngIf="icon == 0"
											(click)="
												getAdData(ads, customchartconfiguration, 'ads', i, k, true);
												currentOpenedAd = k;
												currentOpenedAdGroup = i
											"
										>
											<img src="../../../../../assets/images/right_arrow.png"
										/></span>
										<span
											class="closeIcon"
											*ngIf="icon == 0"
											(click)="expand('ads', i, k, false); currentOpenedAd = -1; currentOpenedAdGroup = -1"
										>
											<img src="../../../../../assets/images/right_arrow.png"
										/></span>
									</div>
								</div>
								<div class="combinations">
									<div class="top5_combinations_title" *ngIf="ads.ad_type == 'RESPONSIVE_SEARCH_AD'">
										Top 5 Combinations
									</div>
									<div class="rows rows_center" [ngClass]="{ other_ad: ads.ad_type != 'RESPONSIVE_SEARCH_AD' }">
										<div class="top-combinations" *ngFor="let combination of ads.top_combinations">
											<div class="headline-title">
												<span *ngIf="combination.ad_type != 'Dynamically_generated_headline'">{{
													combination.name
												}}</span>
												<span *ngIf="combination.ad_type == 'Dynamically_generated_headline'"
													>[{{ combination.name }}]</span
												>
											</div>
											<div class="headline-url">
												<span
													class="headline-ad"
													*ngIf="
														(combination.ad_type == 'EXPANDED_TEXT_AD' ||
															combination.ad_type == 'Dynamically_generated_headline') &&
														combination.website
													"
													>Ad</span
												>
												<span *ngIf="combination.ad_type != 'Dynamically_generated_headline'">{{
													combination.website
												}}</span>
												<span *ngIf="combination.ad_type == 'Dynamically_generated_headline'"
													>[{{ combination.website }}]</span
												>
											</div>
											<div class="headline-description">{{ combination.description }}</div>
											<ng-template [ngIf]="combination.ad_type == 'RESPONSIVE_SEARCH_AD'">
												<div class="bar">
													<div class="colored-bar" [ngStyle]="{ width: combination.percentage + '%' }"></div>
												</div>
												<div class="headline-impressions">
													{{ combination.impressions | number }} impressions ({{ combination.percentage }}%)
												</div>
											</ng-template>
											<ng-template
												[ngIf]="
													combination.ad_type == 'EXPANDED_TEXT_AD' ||
													combination.ad_type == 'Dynamically_generated_headline'
												"
											>
												<div class="location" *ngIf="combination.location || combination.phone">
													<i class="fa fas fa-map-marker" *ngIf="combination.location"></i>
													<span class="location-name" *ngIf="combination.location">{{ combination.location }}</span>
													<span class="location-phone" *ngIf="combination.location && combination.phone">-</span>
													<span class="location-phone">{{ combination.phone }}</span>
												</div>
												<div
													class="sem-creative-card-callouts-container sem-creative-card-roboto"
													*ngIf="combination.calloutsExtn"
												>
													<div>
														<p>
															<span *ngFor="let callout of combination?.calloutsExtn; let i = index"
																>{{ callout
																}}<span [ngClass]="{ last_callout_class: i == combination?.calloutsExtn.length - 1 }">
																	&middot;
																</span></span
															>
														</p>
													</div>
												</div>
												<div
													class="sem-creative-card-structuredsnippets-container sem-creative-card-roboto"
													*ngIf="combination.structuredSnippetExtn"
												>
													<div *ngFor="let snippet of combination?.structuredSnippetExtn">
														<p>{{ snippet?.type }}: {{ snippet?.value }}</p>
													</div>
												</div>
												<div class="site-links" *ngIf="combination.siteLinks">
													<div class="each-site" *ngFor="let site of combination.siteLinks">
														<div class="site-title">{{ site.heading }}</div>
														<div class="site-description">{{ site.description }}</div>
													</div>
												</div>
											</ng-template>
										</div>
									</div>

									<div
										class="timeline-chart"
										*ngIf="
											customchartconfiguration && k == currentOpenedAd && currentOpenedAdGroup == i && (isR13 || isR10)
										"
									>
										<h2>Creative Performance</h2>
										<app-timeline-chart
											[showNoData]="!hasData"
											[data]="ads?.chartData"
											[customchartconfiguration]="customchartconfiguration"
											[uikitresponseconfig]="uikitresponseconfig"
											[nodatamessage]="nodatamessage"
											[seriesviewconfiguration]="seriesviewconfiguration"
											[requestwidgetdata]="false"
										></app-timeline-chart>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="pagination">
					<pagination-template
						id="ad_group_pagination"
						#p="paginationApi"
						(pageChange)="p2 = $event"
						*ngIf="formattedData.length > itemsPerPage"
					>
						<ul class="pager">
							<li [class.disabled]="p.isFirstPage()" style="float: left" class="firstArrow" (click)="p.setCurrent(1)">
								<a>
									<i class="fa fa-step-backward icons"></i>
								</a>
							</li>
							<li [class.disabled]="p.isFirstPage()" class="leftStep" style="float: left" (click)="p.previous()">
								<a>
									<img class="arrow_image" src="../../../../../assets/partner-assets/default-r5/icons/left_arrow.png" />
								</a>
							</li>
							<li
								role="button"
								*ngFor="let page of p.pages"
								[class.current]="p.getCurrent() === page.value"
								class="pages"
								style="float: left"
								(click)="p.setCurrent(page.value)"
							>
								<a *ngIf="p.getCurrent() !== page.value">
									{{ page.label }}
								</a>
								<a *ngIf="p.getCurrent() === page.value" [class.primary-color]="p.getCurrent() === page.value">
									{{ page.label }}
								</a>
							</li>
							<li [class.disabled]="p.isLastPage()" class="rightStep" style="float: left" (click)="p.next()">
								<a>
									<img
										class="arrow_image"
										src="../../../../../assets/partner-assets/default-r5/icons/right_arrow.png"
									/>
								</a>
							</li>
							<li
								[class.disabled]="p.isLastPage()"
								style="float: left"
								class="lastArrow"
								(click)="p.setCurrent(p.getLastPage())"
							>
								<a>
									<i class="fa fa-step-forward icons"></i>
								</a>
							</li>
						</ul>
					</pagination-template>
				</div>
			</div>
		</div>
	</div>
	<!-- </div> -->
	<!-- when there is no data -->
	<div class="no-data" *ngIf="!hasData">
		<div class="no-data-container">{{ nodatamessage }}</div>
	</div>
	<!-- END of no data div -->
</div>
